/* Purchase mode and delivery rituals backed by Shopify allocations and the native Dawn form. */
if (!customElements.get('caene-purchase')) {
  customElements.define('caene-purchase', class extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('product-info');
      this.form = this.closest('form');
      this.preview = this.dataset.preview === 'true';
      this.plans = JSON.parse(this.querySelector('[data-cp-plans]').textContent);
      const remembered = this.querySelector(`[data-cp-ritual][value="${this.dataset.selectedQuantity || 1}"]`);
      if (remembered) remembered.checked = true;
      this.onChange = () => this.sync();
      this.addEventListener('change', this.onChange);
      this.validate = (event) => {
        if (!this.canPurchase) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      };
      this.form.addEventListener('submit', this.validate, true);
      // Hela köptypskortet ska välja sin köptyp. label.cp__head täcker bara 88 av
      // prenumerationskortets 241 px; förmånslistan under (151 px = 63 % av ytan)
      // hade ingen klickyta alls, så ett tryck på "Up to 25% off on every order"
      // gav ingen respons och kunden kunde tro att prenumeration inte går att
      // välja. QA 2026-09-20 P2-2, åtgärdat 2026-09-21.
      this.onCardClick = (event) => {
        const target = event.target;
        if (!target || typeof target.closest !== 'function') return;
        // Äkta interaktiva element sköter sig själva — frekvensvalen, villkorslänken.
        if (target.closest('a, button, input, select, textarea, label')) return;
        const card = target.closest('[data-cp-card]');
        if (!card) return;
        const radio = card.querySelector('[data-cp-mode]');
        if (!radio || radio.checked || radio.disabled) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      };
      this.addEventListener('click', this.onCardClick);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
        if (String(data.sectionId) !== this.dataset.section) return;
        const next = data.html.querySelector('caene-purchase');
        if (!next) return;
        const replacement = next.cloneNode(true);
        replacement.dataset.selectedQuantity = String(this.querySelector('[data-cp-ritual]:checked')?.value || 1);
        const selected = this.querySelector('[data-cp-mode]:checked')?.value;
        const match = replacement.querySelector(`[data-cp-mode][value="${selected}"]`);
        if (match) {
          replacement.querySelectorAll('[data-cp-mode]').forEach((radio) => { radio.checked = radio === match; });
        }
        this.replaceWith(replacement);
        requestAnimationFrame(() => replacement.sync());
      });
      this.sync();
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onCardClick);
      this.form?.removeEventListener('submit', this.validate, true);
      this.unsubscribe?.();
    }
    money(cents) {
      return new Intl.NumberFormat(this.dataset.currency === 'SEK' ? 'sv-SE' : 'en', {style:'currency', currency:this.dataset.currency, minimumFractionDigits:0, maximumFractionDigits:2}).format(cents / 100);
    }
    allowed(count) {
      const min = Number(this.dataset.min || 1);
      const step = Number(this.dataset.step || 1);
      const max = this.dataset.max ? Number(this.dataset.max) : Infinity;
      const stock = this.hasAttribute('data-stock') ? Number(this.dataset.stock) : Infinity;
      return this.dataset.available === 'true' && count >= min && (count-min) % step === 0 && count <= Math.min(max,stock);
    }
    sync() {
      const unit = Number(this.dataset.unitPrice);
      const radios = [...this.querySelectorAll('[data-cp-mode]')];
      const rituals = [...this.querySelectorAll('[data-cp-ritual]')];
      rituals.forEach((radio) => {
        const count = Number(radio.value);
        const allocation = this.plans.find((entry) => entry.quantity === count);
        radio.disabled = !this.allowed(count) || !allocation;
        const card = radio.closest('[data-cp-ritual-card]');
        const discounted = allocation && allocation.unit < unit;
        card.querySelector('[data-cp-ritual-total]').textContent = allocation ? this.money(allocation.unit * count) : 'Unavailable';
        card.querySelector('[data-cp-ritual-compare]').textContent = this.money(unit * count);
        card.querySelector('[data-cp-ritual-compare]').hidden = !discounted;
        card.querySelector('[data-cp-ritual-discount]').textContent = discounted ? `−${Math.round((1 - allocation.unit / unit) * 100)}%` : '';
        card.querySelector('[data-cp-ritual-discount]').hidden = !discounted;
      });
      let ritual = rituals.find((radio) => radio.checked && !radio.disabled);
      if (!ritual) {
        ritual = rituals.find((radio) => !radio.disabled);
        rituals.forEach((radio) => { radio.checked = radio === ritual; });
      }
      radios.forEach((radio) => {
        radio.disabled = radio.value === 'once' ? !this.allowed(1) : !ritual;
      });
      let selected = radios.find((radio) => radio.checked && !radio.disabled);
      if (!selected) {
        selected = radios.find((radio) => !radio.disabled);
        radios.forEach((radio) => { radio.checked = radio === selected; });
      }
      const subscription = selected?.value === 'subscription';
      this.count = subscription ? Number(ritual?.value || 1) : 1;
      const plan = subscription ? this.plans.find((entry) => entry.quantity === this.count) : null;
      const displayedPlan = this.plans.find((entry) => entry.quantity === Number(ritual?.value || 1));
      const onceTotal = unit;
      const subTotal = plan ? plan.unit * this.count : null;
      const interval = this.count === 1 ? '1 pouch every month' : `${this.count} pouches every ${this.count} months`;
      const set = (selector, value) => { const node = this.querySelector(selector); if (node) node.textContent = value; };
      set('[data-cp-once-total]', this.money(onceTotal));
      set('[data-cp-sub-price]', displayedPlan ? this.money(displayedPlan.unit * displayedPlan.quantity) : 'Unavailable');
      set('[data-cp-sub-caption]', subscription ? `${interval} · per delivery` : 'Per delivery · choose your ritual');
      const maxDiscount = Math.max(0, ...this.plans.filter(entry => rituals.some(radio => !radio.disabled && Number(radio.value) === entry.quantity)).map(entry => unit > 0 ? Math.round((1-entry.unit/unit)*100) : 0));
      set('[data-cp-max-discount]', maxDiscount ? `Save up to ${maxDiscount}%` : '');
      const selectedDiscount = plan && unit > 0 ? Math.round((1 - plan.unit / unit) * 100) : maxDiscount;
      set('[data-cp-benefit-discount]', `${subscription ? '' : 'Up to '}${selectedDiscount}% off on every order`);
      const terms = this.querySelector('[data-cp-terms]');
      if (terms) terms.hidden = !subscription;
      const details = this.querySelector('[data-cp-details]');
      if (details) details.hidden = !subscription;
      this.querySelector('[data-cp-mode][value="subscription"]')?.setAttribute('aria-expanded', String(subscription));
      this.querySelector('[data-purchase-quantity]').value = this.count;
      const planInput = this.querySelector('[data-cp-selling-plan]');
      planInput.disabled = !subscription || !plan;
      planInput.value = subscription && plan ? plan.id : '';
      this.valid = Boolean(selected && !selected.disabled && this.allowed(this.count) && (!subscription || plan));
      this.canPurchase = this.valid;
      const total = subscription ? subTotal : onceTotal;
      const formatted = total == null ? '—' : this.money(total);
      set('[data-cp-selection-price]',formatted);
      set('[data-purchase-total]',`${subscription ? 'Per delivery' : 'Total'} ${formatted}`);
      this.product.querySelectorAll('[data-purchase-summary]').forEach((node) => {node.textContent = formatted;});
      this.product.querySelectorAll('[data-purchase-mode]').forEach((node) => {node.textContent = subscription ? interval : 'One-time purchase';});
      const submit = this.form.querySelector('button[type="submit"]');
      if (submit) {
        submit.disabled = !this.canPurchase;
        const label = submit.querySelector('span');
        if (label) label.textContent = this.preview || this.valid ? `Add to cart  |  ${formatted}` : (this.dataset.available === 'true' ? 'Unavailable' : 'Sold out');
      }
      const error = this.querySelector('[data-cp-error]');
      error.hidden = this.preview || this.valid;
      error.textContent = this.valid ? '' : 'This purchase option is currently unavailable.';
    }
  });
}

if (!customElements.get('caene-product-layout')) {
  customElements.define('caene-product-layout', class extends HTMLElement {
    connectedCallback() {
      this.info = this.querySelector('.product__info-wrapper');
      this.media = this.querySelector('.product__media-wrapper');
      this.gallery = this.querySelector('.product__media-list');
      if (!this.info || !this.media || !this.gallery) return;
      const submit = this.querySelector('product-form button[type="submit"]');
      const mobileSubmit = this.querySelector('[data-mobile-submit]');
      this.syncButton = () => {
        if (!submit) return;
        [mobileSubmit].filter(Boolean).forEach((button) => {
          button.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
          const label = submit.querySelector('span')?.textContent.trim() || submit.textContent.trim();
          button.textContent = /^Add to cart/i.test(label) ? 'ADD TO CART' : label;
          button.setAttribute('aria-busy', String(submit.classList.contains('loading')));
        });
      };
      this.observer = new MutationObserver(this.syncButton);
      if (submit) this.observer.observe(submit, { attributes: true, childList: true, subtree: true, characterData: true });
      this.syncButton();
      const buyBar = this.querySelector('.caene-pdp__buy-bar');
      this.syncBuyBar = () => {
        if (!submit || !buyBar) return;
        const rect = submit.getBoundingClientRect();
        const infoTop = this.info.getBoundingClientRect().top;
        // Keep a gallery action, then defer to the main button until it has passed.
        const visible = innerWidth < 750
          ? (infoTop >= innerHeight * 0.5 && rect.top >= innerHeight) || rect.bottom <= 0
          : infoTop < innerHeight && rect.bottom <= 80;
        buyBar.classList.toggle('is-visible', visible);
        if (visible && innerWidth < 750) {
          const height = Math.ceil(buyBar.getBoundingClientRect().height);
          if (height > 0) document.body.style.setProperty('--caene-buy-bar-height', `${height}px`);
        }
      };
      window.addEventListener('scroll', this.syncBuyBar, { passive:true });
      window.addEventListener('resize', this.syncBuyBar);
      this.buyObserver = new ResizeObserver(this.syncBuyBar);
      this.buyObserver.observe(this.info);
      if (buyBar) this.buyObserver.observe(buyBar);
      this.syncBuyBar();
      this.refreshCount = async () => {
        this.countRequest?.abort();
        this.countRequest = new AbortController();
        try {
          const url = new URL(window.routes.cart_url, location.origin);
          url.searchParams.set('section_id', 'cart-icon-bubble');
          const response = await fetch(url, { signal: this.countRequest.signal });
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const replacement = html.querySelector('.cart-count-bubble');
          const header = document.getElementById('cart-icon-bubble');
          const previous = header?.querySelector('.cart-count-bubble');
          if (previous) {
            if (replacement) previous.replaceWith(replacement);
            else previous.remove();
          } else if (header && replacement) header.append(replacement);
        } catch (error) {
          if (error.name !== 'AbortError') console.warn('Cart count refresh failed', error);
        }
      };
      document.addEventListener('rebuy:cart.change', this.refreshCount);
      // Dawn's successful add updates its own sections; refresh Rebuy's separate cart copy.
      this.refreshRebuyCart = () => {
        if (!window.Rebuy?.Cart?.fetchShopifyCart) return;
        window.Rebuy.Cart.fetchShopifyCart((cart) => {
          // Rebuy may consume its preloaded cart from before the native add.
          // A missing added line needs a fresh read, never a second add request.
          const expected = this.rebuyAddedLine;
          const isCurrent = !expected || cart?.items?.some(item => item.key === expected.key && item.quantity >= expected.quantity);
          if (isCurrent) window.Rebuy?.SmartCart?.show();
          else window.Rebuy.Cart.fetchShopifyCart(() => window.Rebuy?.SmartCart?.show());
        });
      };
      this.cartUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source !== 'product-form') return;
        this.rebuyAddedLine = event.cartData;
        // Early adds can finish before Rebuy's initial empty-cart request.
        // Refresh after its ready event so that initial state cannot replace the added item.
        if (window.Rebuy?.SmartCart?.status === 'ready') this.refreshRebuyCart();
        else document.addEventListener('rebuy:smartcart.ready', this.refreshRebuyCart, { once: true });
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.buyObserver?.disconnect();
      document.body.style.removeProperty('--caene-buy-bar-height');
      window.removeEventListener('scroll', this.syncBuyBar);
      window.removeEventListener('resize', this.syncBuyBar);
      this.cartUnsubscribe?.();
      document.removeEventListener('rebuy:smartcart.ready', this.refreshRebuyCart);
      document.removeEventListener('rebuy:cart.change', this.refreshCount);
      this.countRequest?.abort();
    }
  });
}

/* Open the full facts disclosure from the ingredient overview. */
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-caene-full-ingredients]');
  if (!link) return;
  const target = document.getElementById(link.hash.slice(1));
  if (!target) return;
  event.preventDefault();
  target.open = true;
  target.querySelector('summary')?.focus({ preventScroll: true });
  target.scrollIntoView({ block: 'start', behavior: 'instant' });
});
